import React from 'react';
export const Disclaimer = () => {
  return <main className="w-full bg-white py-16" data-id="element-287">
      <div className="container mx-auto px-4" data-id="element-288">
        <h1 className="text-4xl font-bold mb-8 text-center" data-id="element-289">Disclaimer</h1>
        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100" data-id="element-290">
          <p className="text-gray-500 mb-8 text-sm" data-id="element-291">
            Last updated: January 1, 2023
          </p>
          <section className="mb-10" data-id="element-292">
            <p className="text-gray-700 mb-4" data-id="element-293">
              All the information on this website -
              https://www.binary-solutions.co.za/ - is published in good faith
              and for general information purpose only. Binary Solutions does
              not make any warranties about the completeness, reliability and
              accuracy of this information. Any action you take upon the
              information you find on this website (Binary Solutions), is
              strictly at your own risk. Binary Solutions will not be liable for
              any losses and/or damages in connection with the use of our
              website.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-294">
              From our website, you can visit other websites by following
              hyperlinks to such external sites. While we strive to provide only
              quality links to useful and ethical websites, we have no control
              over the content and nature of these sites. These links to other
              websites do not imply a recommendation for all the content found
              on these sites. Site owners and content may change without notice
              and may occur before we have the opportunity to remove a link
              which may have gone 'bad'.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-295">
              Please be also aware that when you leave our website, other sites
              may have different privacy policies and terms which are beyond our
              control. Please be sure to check the Privacy Policies of these
              sites as well as their "Terms of Service" before engaging in any
              business or uploading any information.
            </p>
          </section>
          <section className="mb-10" data-id="element-296">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-297">Consent</h2>
            <p className="text-gray-700 mb-4" data-id="element-298">
              By using our website, you hereby consent to our disclaimer and
              agree to its terms.
            </p>
          </section>
          <section className="mb-10" data-id="element-299">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-300">Update</h2>
            <p className="text-gray-700 mb-4" data-id="element-301">
              Should we update, amend or make any changes to this document,
              those changes will be prominently posted here.
            </p>
          </section>
          <section data-id="element-302">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-303">Contact Us</h2>
            <p className="text-gray-700 mb-4" data-id="element-304">
              If you have any questions about this Disclaimer, please contact
              us:
            </p>
            <ul className="list-disc pl-8 mb-4 text-gray-700" data-id="element-305">
              <li data-id="element-306">Email: am@binary-solutions.co.za</li>
              <li data-id="element-307">Phone: + 27 677 834 937</li>
              <li data-id="element-308">
                Address: 296 francis baard street office 0314, pretoria cbd,
                gauteng, 0002
              </li>
            </ul>
          </section>
        </div>
      </div>
    </main>;
};